import React from 'react';
import Highlight from 'react-highlight/lib/optimized';
import { DemoDatasourcesProps } from '../../models';

const DemoDatasources: React.FC<DemoDatasourcesProps> = ({ datasources }) => {
  return (
    <div className="w-0 min-w-full">
      <div>Queries</div>
      <div className="text-xs">If "enabled" is set to false, static data will be used.</div>
      <div className="flex-1 overflow-auto">
        <Highlight languages={['json']} className="json text-xs pre-wrap">
          {JSON.stringify(datasources ?? {}, null, 2)}
        </Highlight>
      </div>
      {/* TODO: Display input data */}
      {/* <div>Static Data</div>
          <Highlight className="json text-xs max-w-screen-xl pre-wrap">{JSON.stringify(json?.props?.seriesData ?? [], null, 2)}</Highlight> */}
      {/* TODO: Allow input data */}
    </div>
  );
};

export default DemoDatasources;
